<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">{{ data.titulo }}</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  @if (carregando) {
    <app-loading-box-default-list></app-loading-box-default-list>
  } @else if (!movimentacoes.length) {
    <app-empty-state icon="inventory_2" title="Nenhuma movimentação encontrada."></app-empty-state>
  } @else {
    <div class="desktop-view">
      <table mat-table [dataSource]="movimentacoes" class="w-100">
        <ng-container matColumnDef="data">
          <th mat-header-cell *matHeaderCellDef>Data</th>
          <td mat-cell *matCellDef="let m" class="mev-nowrap">{{ m.datetimeMovimentacao | date: 'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="produto">
          <th mat-header-cell *matHeaderCellDef>Produto</th>
          <td mat-cell *matCellDef="let m">
            <ng-container [ngTemplateOutlet]="produto" [ngTemplateOutletContext]="{ $implicit: m }"></ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="localizacao">
          <th mat-header-cell *matHeaderCellDef>Localização</th>
          <td mat-cell *matCellDef="let m">{{ m.nomeLocalizacaoEstoque }}</td>
        </ng-container>

        <ng-container matColumnDef="operacao">
          <th mat-header-cell *matHeaderCellDef>Operação</th>
          <td mat-cell *matCellDef="let m">
            <ng-container [ngTemplateOutlet]="operacao" [ngTemplateOutletContext]="{ $implicit: m }"></ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="quantidade">
          <th mat-header-cell *matHeaderCellDef class="text-end">Quantidade</th>
          <td mat-cell *matCellDef="let m" class="text-end mev-nowrap">
            {{ m.quantidade | abnt: 'quantidade' }}{{ m.unidade ? ' ' + m.unidade : '' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="custo">
          <th mat-header-cell *matHeaderCellDef class="text-end">Custo unit.</th>
          <td mat-cell *matCellDef="let m" class="text-end mev-nowrap">
            {{ m.custoUnitario != null ? (m.custoUnitario | abnt: 'preco') : '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="documento">
          <th mat-header-cell *matHeaderCellDef>Documento</th>
          <td mat-cell *matCellDef="let m">
            {{ m.numeroDocumentoOrigem || '—' }}
            @if (m.descricaoOrigem) { <div class="mev-sub">{{ m.descricaoOrigem }}</div> }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunas"></tr>
        <tr mat-row *matRowDef="let m; columns: colunas"></tr>
      </table>
    </div>

    <div class="mobile-view">
      @for (m of movimentacoes; track m.idEstoqueMovimentacao) {
        <div class="card-mobile mb-3">
          <div class="card-header-mobile">
            <ng-container [ngTemplateOutlet]="produto" [ngTemplateOutletContext]="{ $implicit: m }"></ng-container>
          </div>
          <div class="card-body-mobile p-3">
            <p class="mb-1"><strong>Data:</strong> {{ m.datetimeMovimentacao | date: 'dd/MM/yyyy HH:mm' }}</p>
            <p class="mb-1"><strong>Localização:</strong> {{ m.nomeLocalizacaoEstoque }}</p>
            <p class="mb-1">
              <strong>Operação:</strong>
              <ng-container [ngTemplateOutlet]="operacao" [ngTemplateOutletContext]="{ $implicit: m }"></ng-container>
            </p>
            <p class="mb-1">
              <strong>Quantidade:</strong> {{ m.quantidade | abnt: 'quantidade' }}{{ m.unidade ? ' ' + m.unidade : '' }}
            </p>
            @if (temCusto) {
              <p class="mb-1">
                <strong>Custo unit.:</strong> {{ m.custoUnitario != null ? (m.custoUnitario | abnt: 'preco') : '—' }}
              </p>
            }
            <p class="mb-0">
              <strong>Documento:</strong> {{ m.numeroDocumentoOrigem || '—' }}
              @if (m.descricaoOrigem) { <span class="mev-sub"> · {{ m.descricaoOrigem }}</span> }
            </p>
          </div>
        </div>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>

<!-- Nome do produto (abre o controle de estoque em nova aba) com SKU, lote e série. -->
<ng-template #produto let-m>
  <button type="button" class="mev-produto-link" (click)="abrirProduto(m.idProduto)"
    matTooltip="Abrir controle de estoque do produto em nova aba">{{ m.nomeProduto }}</button>
  @if (m.codigoSku) { <div class="mev-sub">SKU {{ m.codigoSku }}</div> }
  @if (m.codigoLote) { <div class="mev-sub">Lote {{ m.codigoLote }}</div> }
  @if (m.codigoSerie) { <div class="mev-sub">Série {{ m.codigoSerie }}</div> }
</ng-template>

<ng-template #operacao let-m>
  <span class="mev-operacao" [class.is-saida]="!m.isEntrada">
    <mat-icon class="material-symbols-outlined">{{ m.isEntrada ? 'south_west' : 'north_east' }}</mat-icon>
    {{ m.descricaoTipoOperacaoEstoque }}
  </span>
</ng-template>
